import { constructionCalendar } from "./construction";
import { designCalendar } from "./design";
import { plantsCalendar } from "./plants";
import { pestsCalendar } from "./pests";
import { mulchCalendar } from "./mulch";
import { fertiliseCalendar } from "./fertilise";

export const calendar = [
  ...constructionCalendar,
  ...designCalendar,
  ...plantsCalendar,
  ...pestsCalendar,
  ...mulchCalendar,
  ...fertiliseCalendar,
];
